/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { SideMenuLink as SharedSideMenuLink } from "@/shared/ui/components/composed/side-menu";
import type { SideMenuLinkProps as SharedSideMenuLinkProps } from "@/shared/ui/components/composed/side-menu";

export type SideMenuLinkProps = SharedSideMenuLinkProps & {
  linkTo: string;
};

export const SideMenuLink: Component<SideMenuLinkProps> = ({ linkTo, ...props }) => {
  // Preserve app routing prefix while reusing shared styles/structure.
  const normalizedLinkTo = linkTo.startsWith("/") ? linkTo : `/app/${linkTo}`;
  return <SharedSideMenuLink {...props} linkTo={normalizedLinkTo} />;
};
